import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-trends-page-footer',
  templateUrl: './trends-page-footer.component.html',
  styleUrls: ['./trends-page-footer.component.scss']
})
export class TrendsPageFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
